import { Grid } from "@material-ui/core";
import React from 'react';
import { Bar, BarChart, CartesianGrid, Label, Legend, Tooltip, XAxis, YAxis, ResponsiveContainer } from 'recharts';
  
const BarchartStock = (props) => {
  
// Sample data
const data = [
    {
      "name": "Jan",
      "claims submitted": 14,
      "settled": 2
    },
    {
      "name": "Feb",
      "claims submitted": 13,
      "settled": 12
    },
    {
      "name": "Mar",
      "claims submitted": 16,
      "settled": 4
    },
    {
      "name": "Apr",
      "claims submitted": 22,
      "settled": 2
    },
    {
      "name": "May",
      "claims submitted": 7,
      "settled": 4
    },
   
  ]
  
  
return (
<ResponsiveContainer width="95%" height={400}>
{/* <Grid item  xl={6} lg={6} md={6} sm={12} > */}

    <BarChart width={900} height={450} spacing ={2} data={props.data} margin={{ top: 60, right: 20,  bottom: 20 , left: 30}}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="monthyear">
        <Label value="Month" offset={-10} position="insideBottomRight" />
        {props.state?
        <Label value="Cash Claim Settlement" offset={340} position="insideBottomRight" />
      :<Label value="Stock Claim Settlement" offset={110} position="insideBottomRight" />}
        </XAxis>
        <YAxis label={{ value: 'Settled Amount (in Lac)', angle: -90, position: 'insideLeft', textAnchor: 'middle' }} />
        <Tooltip />
        <Legend />
        <Bar dataKey="totalclaim" name="Lodged" fill="#5063de" />
        <Bar 
        // label={{ position:"insideBottomRight"  }} 
        dataKey="settled" name="Settled" fill="#4bca63" />
    </BarChart>
    {/* </Grid> */}
</ResponsiveContainer>
);
}

export default BarchartStock;